export default __webpack_public_path__ + "locales/lo-LA/SharingPanel.json?hash=72fde3756619d0e5b12363fd883fd7ba";